import React, { Component } from "react";

import PropTypes from "prop-types";

import Reaptcha from "reaptcha";
import constants from "common/constants";
import { connect } from "react-redux";
import Actions from "modules/auth/auth-actions";
import FormattedMessageHtml from "modules/i18n/formatted-message-html";

class CustomCaptcha extends Component {
  static propTypes = {
    goTo: PropTypes.func.isRequired,
    setLoginMethod: PropTypes.func.isRequired,
    routeRedirect: PropTypes.string.isRequired
  };
  constructor(props) {
    super(props);
    this.state = {
      verified: false
    };
  }
  onVerify = () => {
    const { routeRedirect, goTo } = this.props;
    this.setState({
      verified: true
    });
    this.props.setLoginMethod();
    goTo(routeRedirect);
  };

  showFakeLogin() {
    return (
      process.env.REACT_APP_ENV !== "production" &&
      !!localStorage.getItem("fakeLogin")
    );
  }

  render() {
    const { verified } = this.state;
    const { lang } = this.props;
    return (
      <div className="captcha-wrapper">
        <div className="captcha-button-wrapper">
          <p>
            <FormattedMessageHtml id="root.start-diagnosis.email" />
          </p>
          {!verified && (
            <React.Fragment>
              {this.showFakeLogin() && (
                <button onClick={this.onVerify}>Login</button>
              )}
              <Reaptcha
                sitekey={constants.reCaptchaKey}
                onVerify={this.onVerify}
                hl={lang}
              />
            </React.Fragment>
          )}
        </div>
      </div>
    );
  }
}

export default connect(
  () => ({}),
  dispatch => ({
    setLoginMethod: () =>
      dispatch(Actions.Creators.setLoginMethod(constants.LoginMethod.Email))
  })
)(CustomCaptcha);



// WEBPACK FOOTER //
// ./src/modules/general-info/custom-captcha.js